import { IntlClass } from '@fx-ui/intl';

export const platformIntl = new IntlClass();
